/*
 * @Author: Zhouqi
 * @Date: 2025-11-12 19:55:45
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-24 11:30:30
 */
import React from 'react';

import { CollapseIcon } from './icon';

interface DrawerCollapseButtonProps {
  className?: string;
  onClick?: () => void;
}

const DrawerCollapseButton: React.FC<DrawerCollapseButtonProps> = ({
  className,
  onClick,
}) => {
  return (
    <span
      className={className || 'absolute top-[10px] right-[18px] cursor-pointer z-[999]'}
      onClick={onClick}
    >
      <CollapseIcon />
    </span>
  );
};

export default DrawerCollapseButton;
